import ylgndata from "./raw/ylgn.json";

export const YlGnColorMap = (type) => {
  if (type === "range") {
    return ylgndata;
  }
};
